var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    d: "M10.272 8.397c-.006-1.147.512-2.013 1.562-2.65-.587-.84-1.475-1.303-2.646-1.394C8.078 4.266 6.866 5 6.422 5c-.469 0-1.544-.616-2.388-.616C2.291 4.412.438 5.775.438 8.547q0 1.228.45 2.537c.4 1.147 1.843 3.96 3.35 3.913.787-.019 1.343-.56 2.368-.56.994 0 1.51.56 2.388.56 1.518-.022 2.825-2.578 3.206-3.728-2.037-.96-1.928-2.813-1.928-2.872M8.503 3.266c.853-1.013.775-1.935.75-2.266-.753.044-1.625.513-2.122 1.09-.547.62-.868 1.385-.8 2.248.816.062 1.56-.357 2.172-1.072"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.313 0h12v16h-12z"
  })))));
};
export default SvgApple;